import React from 'react';
import { IconCalendar } from '@tabler/icons-react';
import { formatLiveTime } from '../utils/time';

// Anchors "who's in/out" views to a concrete day, in whichever timezone the
// caller passes (CST by default team-wide, or the viewer's own if they've
// toggled to local) — without this, statuses read as if they're always
// "right now" even when the underlying log might be from days ago.
export default function TodayBadge({ timezone }) {
  const { date } = formatLiveTime(timezone);
  return (
    <span className="inline-flex items-center gap-1.5 text-xs font-medium text-muted bg-card-tint border border-border rounded-full px-3 py-1">
      <IconCalendar size={14} stroke={1.8} />
      Today: {date} ({timezone})
    </span>
  );
}
